import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name;
  return <div className="w-full" data-id="element-536">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-537">
          {label}
        </label>}
      <select id={selectId} className={`block w-full rounded-lg border-gray-300 border shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 transition-colors ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-538">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-539">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-540">{error}</p>}
    </div>;
}